// import PropTypes from "prop-types";
// import { useState } from "react";
// import { toast } from "react-hot-toast";
// import { useUploadFilesMutation } from "@/features/api/leadsApi";
// import { Loader2 } from "lucide-react";
// import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
// import { Input } from "@/components/ui/input";
// import { Label } from "@/components/ui/label";
// import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

// const DocumentationForm = ({ form, handleChange, formErrors, isSaving }) => {
//   const [uploadStatus, setUploadStatus] = useState({});
//   const [uploadFileApi] = useUploadFilesMutation();

//   const uploadFile = async (file, fieldName) => {
//     if (!file) {
//       setUploadStatus(prev => ({ ...prev, [fieldName]: "No file selected" }));
//       return null;
//     }

//     const allowedTypes = [
//       "application/pdf",
//       "image/jpeg",
//       "image/png",
//       "image/webp",
//       "video/mp4",
//       "audio/mp3",
//     ];

//     if (!allowedTypes.includes(file.type)) {
//       setUploadStatus(prev => ({
//         ...prev,
//         [fieldName]: "Invalid type. Only PDF, JPEG, PNG, WebP, MP4, or MP3 allowed.",
//       }));
//       return null;
//     }

//     if (file.size > 50 * 1024 * 1024) {
//       setUploadStatus(prev => ({ ...prev, [fieldName]: "File exceeds 50MB limit." }));
//       return null;
//     }

//     const formData = new FormData();
//     formData.append("file", file);

//     setUploadStatus(prev => ({ ...prev, [fieldName]: "loading" }));

//     try {
//       const data = await uploadFileApi(formData).unwrap();
//       setUploadStatus(prev => ({ ...prev, [fieldName]: null }));
//       return data.fileUrl;
//     } catch (error) {
//       setUploadStatus(prev => ({
//         ...prev,
//         [fieldName]: error?.data?.message || "Upload failed",
//       }));
//       return null;
//     }
//   };

//   const handleFileChange = async e => {
//     const { name, files } = e.target;
//     if (files?.[0]) {
//       const fileUrl = await uploadFile(files[0], name);
//       if (fileUrl) {
//         handleChange({ target: { name, value: fileUrl } });
//         toast.success(`${name} uploaded successfully`);
//       } else {
//         toast.error(`Failed to upload ${name}`);
//       }
//     }
//   };

//   // File structure for all services with tabs
//   const documentationTabs = {
//     studyAbroad: {
//       Personal: [
//         { name: "passport", label: "Passport" },
//         { name: "passportPhotograph", label: "Passport sized Photograph" },
//         { name: "aadhaarCard", label: "Aadhaar Card" },
//         { name: "birthCertificate", label: "Copy of Birth Certificate" },
//         { name: "cv", label: "CV" },
//         { name: "parentsPassport", label: "Parent's Passport" },
//         { name: "itinerary", label: "Itinerary" },
//         { name: "visaCopy", label: "Visa Copy" },
//       ],
//       Professional: [
//         { name: "tenthResult", label: "10th Result" },
//         { name: "tenthPassingCertificate", label: "10th Passing Certificate" },
//         { name: "eleventhResult", label: "11th Result (Semester wise, NIOS)" },
//         { name: "predictableMarksheet", label: "Predictable Marksheet" },
//         { name: "twelfthResult", label: "12th Result/Diploma" },
//         { name: "twelfthPassingCertificate", label: "12th Passing Certificate/Diploma" },
//         { name: "sop", label: "SOP" },
//         { name: "coverLetter", label: "Cover Letter" },
//         { name: "languageExamCertificate", label: "Language Exam Certificate" },
//         { name: "lorPrincipal", label: "LOR - Principal/HOD" },
//         { name: "lorProfessor1", label: "LOR - Professor 1" },
//         { name: "lorProfessor2", label: "LOR - Professor 2" },
//         { name: "bachelorsMarksheets", label: "Bachelor’s Marksheets (Min. 6)" },
//         { name: "predictableTranscript", label: "Predictable Transcript" },
//         { name: "transcript", label: "Transcript" },
//         { name: "bachelorsProvisional", label: "Bachelor's Provisional Degree/Certificate" },
//         { name: "bachelorsCertificate", label: "Bachelor's Degree" },
//         { name: "wes", label: "WES (if required)" },
//         { name: "internshipWorkExperience", label: "Internship/Work Experience" },
//         { name: "gap", label: "Gap Declaration" },
//       ],
//       Financial: [
//         { name: "bankStatements", label: "Bank Statement (Min 6 Months)" },
//         { name: "bankManagerCertificate", label: "Bank Manager Certificate" },
//         { name: "itr", label: "ITR 3 Years" },
//         { name: "caNetworth", label: "CA Networth" },
//         { name: "companyProof", label: "Company/Job/Farmer's Proof" },
//         { name: "sponsorDocs", label: "Sponsor Documents" },
//         { name: "loanSanctionLetter", label: "LOAN Sanction Letter" },
//       ],
//       Other: [],
//     },
//     workpermit: {
//       Personal: [
//         { name: "passportWorkpermit", label: "Passport" },
//         { name: "passportPhotographWorkpermit", label: "Passport sized Photograph" },
//         { name: "aadhaarCardWorkpermit", label: "Aadhaar Card" },
//         { name: "panCardWorkpermit", label: "PAN Card" },
//         { name: "birthCertificateWorkpermit", label: "Copy of Birth Certificate" },
//         { name: "cvWorkpermit", label: "CV" },
//         { name: "travelHistory", label: "Travel History" },
//         { name: "itineraryWorkpermit", label: "Itinerary" },
//         { name: "visaCopyWorkpermit", label: "Visa Copy" },
//         { name: "pccWorkpermit", label: "PCC" },
//         { name: "marriageCertificateWorkpermit", label: "Marriage Certificate" },
//       ],
//       Professional: [
//         { name: "academicsWorkpermit", label: "Academic Documents" },
//         { name: "sopWorkpermit", label: "SOP" },
//         { name: "coverLetterWorkpermit", label: "Cover Letter" },
//         { name: "languageExamCertificateWorkpermit", label: "Language Exam Certificate" },
//         { name: "workExperienceWorkpermit", label: "Work Experience" },
//         { name: "gapWorkpermit", label: "Gap Declaration" },
//         { name: "nocWorkpermit", label: "NOC" },
//       ],
//       Financial: [
//         { name: "bankStatementWorkpermit", label: "Bank Statement (Min 6 Months)" },
//         { name: "bankManagerCertificateWorkpermit", label: "Bank Manager Certificate" },
//         { name: "salarySlipWorkpermit", label: "Salary Slip" },
//         { name: "itrsWorkpermit", label: "ITR 3 Years/Form 16" },
//         { name: "caNetworthWorkpermit", label: "CA Networth" },
//         { name: "companyProofWorkpermit", label: "Company/Job/Farmer's Proof" },
//       ],
//       Other: [],
//     },
//     touristVisa: {
//       Personal: [
//         { name: "passportTourist", label: "Passport" },
//         { name: "passportPhotographTourist", label: "Passport sized Photograph" },
//         { name: "aadhaarCardTourist", label: "Aadhaar Card" },
//         { name: "birthCertificateTourist", label: "Copy of Birth Certificate" },
//         { name: "cvTourist", label: "CV" },
//         { name: "travelHistoryTourist", label: "Travel History" },
//         { name: "itineraryTourist", label: "Itinerary" },
//         { name: "visaCopyTourist", label: "Visa Copy" },
//         { name: "marriageCertificateTourist", label: "Marriage Certificate" },
//       ],
//       Professional: [
//         { name: "academicsTourist", label: "Academic Documents" },
//         { name: "coverLetterTourist", label: "Cover Letter" },
//         { name: "workExperienceTourist", label: "Work Experience" },
//         { name: "rejectionLetterTourist", label: "Rejection Letter (If Any)" },
//         { name: "nocTourist", label: "NOC" },
//       ],
//       Financial: [
//         { name: "bankStatementsTourist", label: "Bank Statement (Min 6 Months)" },
//         { name: "bankManagerCertificateTourist", label: "Bank Manager Certificate" },
//         { name: "salarySlipTourist", label: "Salary Slip" },
//         { name: "itrsTourist", label: "ITR 3 Years/Form 16" },
//         { name: "caNetworthTourist", label: "CA Networth" },
//         { name: "companyDocsTourist", label: "Company/Job/Farmer's Proof" },
//         { name: "sponsorDocsTourist", label: "Sponsor Documents" },
//       ],
//       Other: [],
//     },
//   };

//   const serviceToDocType = {
//     studyAbroad: "studyAbroad",
//     workpermit: "workpermit",
//     touristVisa: "touristVisa",
//   };

//   const selectedDocType = serviceToDocType[form.service] || null;

//   const renderFields = fields =>
//     fields.map(field => (
//       <div key={field.name} className="relative mt-2">
//         <Label htmlFor={field.name}>{field.label}</Label>
//         <Input
//           id={field.name}
//           name={field.name}
//           type="file"
//           accept="application/pdf,image/jpeg,image/png,image/webp,video/mp4,audio/mp3"
//           onChange={handleFileChange}
//           disabled={isSaving || uploadStatus[field.name] === "loading"}
//         />
//         {formErrors[field.name] && <p className="text-red-500 text-sm mt-1">{formErrors[field.name]}</p>}
//         {uploadStatus[field.name] === "loading" && (
//           <div className="flex items-center gap-2 text-blue-500 mt-1">
//             <Loader2 className="h-4 w-4 animate-spin" /> Uploading...
//           </div>
//         )}
//         {uploadStatus[field.name] && uploadStatus[field.name] !== "loading" && (
//           <p className="text-red-500 text-sm mt-1">{uploadStatus[field.name]}</p>
//         )}
//         {form[field.name] && !uploadStatus[field.name] && (
//           <p className="text-green-500 text-sm mt-1">✅ Uploaded: {form[field.name]}</p>
//         )}
//       </div>
//     ));

//   return (
//     <Card className="p-4 max-w-4xl mx-auto">
//       <CardHeader>
//         <CardTitle>Documentation</CardTitle>
//       </CardHeader>
//       <CardContent>
//         {selectedDocType ? (
//           <Tabs defaultValue="Personal" className="space-y-4">
//             <TabsList className="grid grid-cols-4 w-full">
//               {Object.keys(documentationTabs[selectedDocType]).map(tab => (
//                 <TabsTrigger key={tab} value={tab}>{tab}</TabsTrigger>
//               ))}
//             </TabsList>
//             {Object.entries(documentationTabs[selectedDocType]).map(([tab, fields]) => (
//               <TabsContent key={tab} value={tab} className="pt-4 border-t border-gray-200">
//                 {fields.length ? renderFields(fields) : <p className="text-gray-500">No documents required.</p>}
//               </TabsContent>
//             ))}
//           </Tabs>
//         ) : (
//           <p className="text-gray-500">No documents required for this service.</p>
//         )}
//       </CardContent>
//     </Card>
//   );
// };

// DocumentationForm.propTypes = {
//   form: PropTypes.object.isRequired,
//   handleChange: PropTypes.func.isRequired,
//   formErrors: PropTypes.object.isRequired,
//   isSaving: PropTypes.bool.isRequired,
// };

// export default DocumentationForm;



import PropTypes from "prop-types";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { useUploadFilesMutation } from "@/features/api/leadsApi";
import { Loader2 } from "lucide-react";

const DocumentationForm = ({ form, handleChange, formErrors, isSaving }) => {
  const [uploadStatus, setUploadStatus] = useState({});
  const [uploadFileApi] = useUploadFilesMutation();

  // ✅ Upload a single file
  const uploadFile = async (file, fieldName) => {
    if (!file) {
      setUploadStatus((prev) => ({ ...prev, [fieldName]: "No file selected" }));
      return null;
    }

    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/png",
      "image/webp",
      "video/mp4",
      "audio/mp3",
    ];

    if (!allowedTypes.includes(file.type)) {
      setUploadStatus((prev) => ({
        ...prev,
        [fieldName]: "Invalid type. Only PDF, JPEG, PNG, WebP, MP4, or MP3 allowed.",
      }));
      return null;
    }

    if (file.size > 50 * 1024 * 1024) {
      setUploadStatus((prev) => ({ ...prev, [fieldName]: "File exceeds 50MB limit." }));
      return null;
    }

    const formData = new FormData();
    formData.append("file", file);

    setUploadStatus((prev) => ({ ...prev, [fieldName]: "loading" }));

    try {
      const data = await uploadFileApi(formData).unwrap();
      setUploadStatus((prev) => ({ ...prev, [fieldName]: null }));
      return data.fileUrl;
    } catch (error) {
      setUploadStatus((prev) => ({
        ...prev,
        [fieldName]: error?.data?.message || "Upload failed",
      }));
      return null;
    }
  };

  // ✅ Handle file input
  const handleFileChange = async (e) => {
    const { name, files } = e.target;
    if (files?.[0]) {
      const fileUrl = await uploadFile(files[0], name);
      if (fileUrl) {
        handleChange({ target: { name, value: fileUrl } });
        toast.success(`${name} uploaded successfully`);
      } else {
        toast.error(`Failed to upload ${name}`);
      }
    }
  };

  // ✅ File fields mapping with bifurcation
  const fileFieldsByType = {
    studyAbroad: {
      Personal: [
        { name: "passport", label: "Passport" },
        { name: "passportPhotograph", label: "Passport sized Photograph" },
        { name: "aadhaarCard", label: "Aadhaar Card" },
        { name: "birthCertificate", label: "Copy of Birth Certificate" },
        { name: "cv", label: "CV" },
        { name: "parentsPassport", label: "Parent's Passport" },
        { name: "itinerary", label: "Itinerary" },
        { name: "visaCopy", label: "Visa Copy" },
      ],
      Professional: [
        { name: "tenthResult", label: "10th Result" },
        { name: "tenthPassingCertificate", label: "10th Passing Certificate" },
        { name: "eleventhResult", label: "11th Result (Semester wise, NIOS)" },
        { name: "predictableMarksheet", label: "Predictable Marksheet" },
        { name: "twelfthResult", label: "12th Result/Diploma" },
        { name: "twelfthPassingCertificate", label: "12th Passing Certificate/Diploma" },
        { name: "sop", label: "SOP" },
        { name: "coverLetter", label: "Cover Letter" },
        { name: "languageExamCertificate", label: "Language Exam Certificate" },
        { name: "lorPrincipal", label: "LOR - Principal/HOD" },
        { name: "lorProfessor1", label: "LOR - Professor 1" },
        { name: "lorProfessor2", label: "LOR - Professor 2" },
        { name: "bachelorsMarksheets", label: "Bachelor’s Marksheets (Min. 6)" },
        { name: "predictableTranscript", label: "Predictable Transcript" },
        { name: "transcript", label: "Transcript" },
        { name: "bachelorsProvisionalCertificate", label: "Bachelor's Provisional Degree/Certificate" },
        { name: "bachelorsDegree", label: "Bachelor's Degree" },
        { name: "wes", label: "WES (if required)" },
        { name: "internshipWorkExperience", label: "Internship/Work Experience" },
        { name: "gap", label: "Gap Declaration" },
      ],
      Financial: [
        { name: "bankStatement", label: "Bank Statement (Min 6 Months)" },
        { name: "bankManagerCertificate", label: "Bank Manager’s Certificate" },
        { name: "itrs", label: "ITR 3 Years" },
        { name: "caNetworth", label: "CA Networth" },
        { name: "companyProof", label: "Company/Job/Farmer's Proof" },
        { name: "sponsorDocs", label: "Sponsor Documents" },
        { name: "loanSanctionLetter", label: "Loan Sanction Letter" },
      ],
      Other: [{ name: "otherDocumentsStudyAbroad", label: "Other Documents" }],
    },

    workpermit: {
      Personal: [
        { name: "passportWorkpermit", label: "Passport" },
        { name: "passportPhotographWorkpermit", label: "Passport sized Photograph" },
        { name: "aadhaarCardWorkpermit", label: "Aadhaar Card" },
        { name: "panCardWorkpermit", label: "PAN Card" },
        { name: "birthCertificateWorkpermit", label: "Copy of Birth Certificate" },
        { name: "cvWorkpermit", label: "CV" },
        { name: "travelHistoryWorkpermit", label: "Travel History" },
        { name: "itineraryWorkpermit", label: "Itinerary" },
        { name: "visaCopyWorkpermit", label: "Visa Copy" },
        { name: "pccWorkpermit", label: "PCC" },
        { name: "marriageCertificateWorkpermit", label: "Marriage Certificate" },
      ],
      Professional: [
        { name: "academicsWorkpermit", label: "Academic Documents" },
        { name: "sopWorkpermit", label: "SOP" },
        { name: "coverLetterWorkpermit", label: "Cover Letter" },
        { name: "languageExamCertificateWorkpermit", label: "Language Exam Certificate" },
        { name: "workExperienceWorkpermit", label: "Work Experience" },
        { name: "gapWorkpermit", label: "Gap Declaration" },
        { name: "nocWorkpermit", label: "NOC" },
      ],
      Financial: [
        { name: "bankStatementWorkpermit", label: "Bank Statement (Min 6 Months)" },
        { name: "bankManagerCertificateWorkpermit", label: "Bank Manager’s Certificate" },
        { name: "salarySlipWorkpermit", label: "Salary Slip" },
        { name: "itrsWorkpermit", label: "ITR 3 Years/Form 16" },
        { name: "caNetworthWorkpermit", label: "CA Networth" },
        { name: "companyProofWorkpermit", label: "Company/Job/Farmer's Proof" },
      ],
      Other: [{ name: "otherDocumentsWorkpermit", label: "Other Documents" }],
    },

    touristVisa: {
      Personal: [
        { name: "passportTourist", label: "Passport" },
        { name: "passportPhotographTourist", label: "Passport sized Photograph" },
        { name: "aadhaarCardTourist", label: "Aadhaar Card" },
        { name: "birthCertificateTourist", label: "Copy of Birth Certificate" },
        { name: "cvTourist", label: "CV" },
        { name: "travelHistoryTourist", label: "Travel History" },
        { name: "itineraryTourist", label: "Itinerary" },
        { name: "visaCopyTourist", label: "Visa Copy" },
        { name: "marriageCertificateTourist", label: "Marriage Certificate" },
      ],
      Professional: [
        { name: "academicsTourist", label: "Academic Documents" },
        { name: "coverLetterTourist", label: "Cover Letter" },
        { name: "workExperienceTourist", label: "Work Experience" },
        { name: "rejectionLetterTourist", label: "Rejection Letter (If Any)" },
        { name: "nocTourist", label: "NOC" },
      ],
      Financial: [
        { name: "bankStatementsTourist", label: "Bank Statement (Min 6 Months)" },
        { name: "bankManagerCertificateTourist", label: "Bank Manager’s Certificate" },
        { name: "salarySlipTourist", label: "Salary Slip" },
        { name: "itrsTourist", label: "ITR 3 Years/Form 16" },
        { name: "caNetworthTourist", label: "CA Networth" },
        { name: "companyProofTourist", label: "Company/Job/Farmer's Proof" },
        { name: "sponsorDocsTourist", label: "Sponsor Documents" },
      ],
      Other: [{ name: "otherDocumentsTourist", label: "Other Documents" }],
    },

    examBooking: {
      Personal: [
        { name: "Govrmentid", label: "Government ID" },
        { name: "passportExamBooking", label: "Passport" },
      ],
      Other: [{ name: "otherDocumentsExamBooking", label: "Other Documents" }],
    },
  };

  // ✅ Map service → documentation type
  const serviceToDocType = {
    studyAbroad: "studyAbroad",
    workpermit: "workpermit",
    touristVisa: "touristVisa",
    examBooking: "examBooking",
    training: null,
  };

  const selectedDocType = serviceToDocType[form.service] || null;

  return (
    <Card className="p-4 max-w-3xl mx-auto">
      <CardHeader>
        <CardTitle>Documentation</CardTitle>
      </CardHeader>
      <CardContent>
        <form className="space-y-6">
          {selectedDocType ? (
            Object.entries(fileFieldsByType[selectedDocType]).map(
              ([section, fields]) => (
                <div key={section} className="border-b pb-4 mb-6">
                  <h3 className="text-lg font-semibold mb-3 text-gray-700">
                    {section} Documents
                  </h3>
                  <div className="space-y-4">
                    {fields.map((field) => (
                      <div key={field.name} className="relative">
                        <Label htmlFor={field.name}>{field.label}</Label>
                        <Input
                          id={field.name}
                          name={field.name}
                          type="file"
                          accept="application/pdf,image/jpeg,image/png,image/webp,video/mp4,audio/mp3"
                          onChange={handleFileChange}
                          disabled={
                            isSaving || uploadStatus[field.name] === "loading"
                          }
                        />

                        {/* Error message */}
                        {formErrors[field.name] && (
                          <p className="text-red-500 text-sm mt-1">
                            {formErrors[field.name]}
                          </p>
                        )}

                        {/* Uploading spinner */}
                        {uploadStatus[field.name] === "loading" && (
                          <div className="flex items-center gap-2 text-blue-500 mt-1">
                            <Loader2 className="h-4 w-4 animate-spin" />
                            <span>Uploading...</span>
                          </div>
                        )}

                        {/* Upload error */}
                        {uploadStatus[field.name] &&
                          uploadStatus[field.name] !== "loading" && (
                            <p className="text-red-500 text-sm mt-1">
                              {uploadStatus[field.name]}
                            </p>
                          )}

                        {/* Upload success */}
                        {form[field.name] && !uploadStatus[field.name] && (
                          <p className="text-green-500 text-sm mt-1">
                            ✅ Uploaded: {form[field.name]}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )
            )
          ) : (
            <p className="text-gray-500">No documents required for Training.</p>
          )}
        </form>
      </CardContent>
    </Card>
  );
};

DocumentationForm.propTypes = {
  form: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  formErrors: PropTypes.object.isRequired,
  isSaving: PropTypes.bool.isRequired,
};

export default DocumentationForm;